import React, { useState, useEffect } from "react";
import Amplify, { Auth, Hub } from "aws-amplify";
import awsconfig from "./../../aws-exports";
import { useFormFields } from "../../libs/hooksLib";
import "./forgotPass.css";
import { Link } from "react-router-dom";
import ButtonLoad from "../ButtonLoad";

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_content_delivery_bucket:
    "lawnbotonboarding-20210824161452-hostingbucket-dev",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_url: "https://d2lsflb40vt3k3.cloudfront.net",
  aws_cognito_identity_pool_id:
    "us-east-1:f3521428-4b70-46f3-9050-b1c4e211f376",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_5zEEtmbwg",
  aws_user_pools_web_client_id: "5jv4km9a4b76h2v6pvao43niec",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ["EMAIL"]
};

Amplify.configure(awsmobile);
Auth.configure(awsmobile);

const ForgotPass = () => {
  const [fields, handleFieldChange] = useFormFields({
    code: "",
    email: "",
    password: "",
    confirmPassword: ""
  });

  const [codeSent, setCodeSent] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [userFound, setUserFound] = useState(true);
  const [wrongPass, setWrongPass] = useState(false);
  const [passErrorMsg, setPassErrorMsg] = useState("");
  const [wrongCode, setWrongCode] = useState(false);

  /*
  useEffect(() => {
    validateResetForm();
  }, [setNotIdentical])
*/
  function validateCodeForm() {
    return fields.email.length > 0;
  }

  function validatePassCode() {
    return (
      fields.password === fields.confirmPassword &&
      fields.password.length > 0 &&
      fields.confirmPassword.length > 0
    );
  }

  function validateCodeLength() {
    return fields.code.length > 0;
  }

  async function handleSendCodeClick(event) {
    event.preventDefault();

    setIsSendingCode(true);

    try {
      await Auth.forgotPassword(fields.email);

      setCodeSent(true);
    } catch (error) {
      //onError(error);
      if (error.code === "UserNotFoundException") {
        setUserFound(false);
      }
      setIsSendingCode(false);
    }
  }

  async function resendCode() {
    try {
      await Auth.forgotPassword(fields.email);
      //setIsConfirming(true);
    } catch (error) {
      //setIsConfirming(false);
    }
  }

  async function handleConfirmClick(event) {
    event.preventDefault();

    setIsConfirming(true);

    try {
      await Auth.forgotPasswordSubmit(
        fields.email,
        fields.code,
        fields.password
      );
      setConfirmed(true);
    } catch (error) {
      //onError(error);
      setIsConfirming(false);

      if (error.code === "CodeMismatchException") {
        setWrongCode(true);
      } else if (error.code === "InvalidPasswordException") {
        setPassErrorMsg(error.message);
        setWrongPass(true);
      }
    }
  }

  function renderRequestCodeForm() {
    return (
      <div className="left-div">
        <img className="logo" src="/lawnbotnew.png" alt="" />
        <div className="instructions">Enter your Email </div>
        <form className="form" onSubmit={handleSendCodeClick}>
          <input
            className="input"
            name="email"
            type="email"
            id="email"
            value={fields.email}
            onChange={handleFieldChange}
            placeholder="e-mail"
          />
          {!userFound && <p className="error">Email not found</p>}
          <Link className="link-back" to="/">
            Back to login
          </Link>
          <ButtonLoad
            type="submit"
            isLoading={isSendingCode}
            disabled={!validateCodeForm()}
            className="signIn-button"
            text="Send Code"
          ></ButtonLoad>
        </form>

        <img src="/madein.png" alt="" className="footer-img" />
      </div>
    );
  }

  function renderConfirmationForm() {
    return (
      <div className="left-div">
        <img className="logo" src="/lawnbotnew.png" alt="" />
        <div className="instructions1">
          Please check your email for confirmation code{" "}
        </div>
        <div className="instructions2">Then enter your new password</div>
        <form onSubmit={handleConfirmClick}>
          <input
            className="input"
            type="tel"
            id="code"
            value={fields.code}
            onChange={handleFieldChange}
            placeholder="confirmation code"
          />
          {wrongCode && <p className="error">Wrong code</p>}
          {/*!validateCodeLength() && <p className="error">Enter a code</p>*/}
          <input
            className="input"
            type="password"
            id="password"
            value={fields.password}
            onChange={handleFieldChange}
            placeholder="new password"
          />
          <input
            className="input"
            type="password"
            id="confirmPassword"
            value={fields.confirmPassword}
            onChange={handleFieldChange}
            placeholder="confirm password"
          />
          {!validatePassCode() && (
            <p className="error">Passwords do not match</p>
          )}
          {wrongPass && <p className="error">{passErrorMsg}</p>}
          <Link className="link-back" to="/">
            Back to login
          </Link>
          <ButtonLoad
            type="submit"
            isLoading={isConfirming}
            disabled={!validatePassCode()}
            className="signIn-button"
            text="Confirm"
          ></ButtonLoad>
        </form>
        <div className="resend-code">
          <div>{"Didn't get an email?"} </div>
          <a onClick={resendCode}>Resend Code</a>
        </div>
        <img src="/madein.png" alt="" className="footer-img" />
      </div>
    );
  }

  function renderSuccessMessage() {
    return (
      <div className="left-div">
        <img className="logo" src="/lawnbotnew.png" alt="" />
        <div className="instructions-success">Your password has been reset</div>

        <Link className="link-success" to="/">
          Back to login
        </Link>

        <img src="/madein.png" alt="" className="footer-img" />
      </div>
    );
  }

  return (
    <div className="body">
      {!codeSent
        ? renderRequestCodeForm()
        : !confirmed
        ? renderConfirmationForm()
        : renderSuccessMessage()}

      <div className="right-div">
        <div className="announcement">
          <iframe
            title={"iframe"}
            className="iframe"
            id="announcement-Iframe"
            src="https://lawnbot.biz/announcements/lawnbot_fb_embed.html?buster=61170_iframe"
            frameBorder="0"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ForgotPass;
